export const ProductLocation = (): JSX.Element => <h1>Location</h1>;
